import '../internals/custom-jquery';
import '../internals/global';
import '../internals/acf/kg-rdv';

/**
 * Function utilisée sur le formulaire "Mon rendez-vous"
 */

 (function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { RendezVous : {}});
    /**
     * Initialisation du formulaire
     */
    w.Kinougarde.RendezVous.initFormulaire = function() {                              
        
        Kinougarde.RendezVous.SecurityKey =   (new RegExp("\/mon-rendez-vous\/([^\/]+)\/?","g")).exec(document.location)[1];

        Kinougarde.RendezVous.setMessageConfirmation(Kinougarde_RendezVous.CodeEtatCandidature);        
        
        if (typeof(Kinougarde_RendezVous.DateRendezVous)!=='undefined' && Kinougarde_RendezVous.DateRendezVous!==null && Kinougarde_RendezVous.CodeEtatCandidature==51) {
            // Si une DateDeRendezVous est déjà positionné , on passe directement à l'étape 2
            Kinougarde.formulaireAcf.InitFormulaire({ defaultValue : {'rdv_date': Kinougarde_RendezVous.DateRendezVous}, defaultStep :1});
            $("#etape_confirmation_rdv .acf-message.success p").html( "RDV confirmé</br>" + Kinougarde.AcfKgRdv.GetDateRdv(Kinougarde_RendezVous.DateRendezVous) );
        }
        else if (Kinougarde_RendezVous.CodeEtatCandidature!=60) {
            // Affiche le message de fin du RDV            
            Kinougarde.formulaireAcf.InitFormulaire({ defaultValue : {'rdv_date': Kinougarde_RendezVous.DateRendezVous}, defaultStep :3});
        }
        else {
            Kinougarde.formulaireAcf.InitFormulaire()
        }

        //Capte l'évènement de validation de la date et l'heure de rendez-vous
        $("#etape_date .acf-rdv").on("acf-field-type-rdv-validation-rdv",function() {
            // Modifie le message success
            var dateRdv = Kinougarde.AcfKgRdv.GetDateRdv($("input[name=rdv_date]:checked").val());
            $("#etape_confirmation_rdv .acf-message.success p").html(  "RDV confirmé</br>" + dateRdv );
            // Modifie le message success
            $("#etape_confirmation_annulation .acf-message.success p").html( "RDV annulé</br>" + dateRdv);

            // Passe à l'étape suivante                                                
            Kinougarde.formulaireAcf.NextStep();    
        })

        // Capte l'évènement Généré par Kinougarde.formulaireAcf.NextStep(); lors de la validation de la date et de l'heure (avant l'appel Ajax)                
        $("#etape_date").on("form-step-next-change",function(event, options) {
            // Ajoute la clé de sécurité contenu dans l'url                      
            options.data = {"SecurityKey": Kinougarde.RendezVous.SecurityKey};            
            return options;
        });

        // Click sur le bouton "Déplacer mon RDV"
        $("#bouton_deplacer_rdv").on('click',function(e) {
            e.preventDefault();
            var  $step = Kinougarde.formulaireAcf.CurrentStep();   
            $step.addClass('loading-state'); 

            // Appel Ajax pour vérifier si l'utilisateur n'a pas été intégré entre temps
            $.ajax({
                type     : 'POST',
                dataType : 'json',
                url      : ajax_kinougarde_object.ajaxurl,
                data     : {action : 'ajax_deplacer_rdv',SecurityKey : Kinougarde.RendezVous.SecurityKey},
                success  : function (reponse) { 
                    $step.removeClass('loading-state');
                    if (reponse.data.redirect===false) {
                        // ON reste sur le site
                        Kinougarde.formulaireAcf.PrevStep();
                    } else {
                        // On part sur l'extranet prod
                        document.location.href = reponse.data.redirect;
                    }                    
            } ,
            error: function() {
                $step.removeClass('loading-state');
            }});            
            return false;
        });       

        //Click sur le bouton "Annuler mon RDV"
        $("#bouton_annuler_rdv").on('click',function(e) {
            // Passe à l'étape suivante                                                
            e.preventDefault(); 
            var  $step = Kinougarde.formulaireAcf.CurrentStep();   
            $step.addClass('loading-state'); 
            // Appel Ajax pour vérifier si l'utilisateur n'a pas été intégré entre temps
            $.ajax({
                type     : 'POST',
                dataType : 'json',
                url      : ajax_kinougarde_object.ajaxurl,
                data     : {action : 'ajax_deplacer_rdv',SecurityKey : Kinougarde.RendezVous.SecurityKey},
                success  : function (reponse) { 
                    if (reponse.data.redirect===false) {
                        // ON reste sur le site
                        Kinougarde.formulaireAcf.NextStep();                            
                    } else {
                        // On part sur l'extranet prod
                        document.location.href = reponse.data.redirect;
                    }
            }});            
            return false;            
        });

         //Click sur le bouton "Prendre un RDV"
         $("#bouton_reprendre_rdv").on('click',function(e) {
            //Retourne sur la première étape                                               
            e.preventDefault();
            Kinougarde.formulaireAcf.NextStep({ 'stepIndex' : 0});    
        });

        // Capte l'évènement Généré par Kinougarde.formulaireAcf.NextStep(); lors du clic sur "annuler RDV"         
         $("#etape_confirmation_rdv").on("form-step-next-change",function(event, options) {
            // Ajoute la clé de sécurité contenu dans l'url                      
            options.data = {"SecurityKey": Kinougarde.RendezVous.SecurityKey};            
            return options;
        });

        // Mise à jour des infos de l'agence
        Kinougarde.UpdateAgence(Kinougarde_RendezVous.Agence);        
                                                         
    }; 
    
    /**
     * Retourne true si le candidat est ciblé
     * @param {*} codeEtatCandidature 
     * @returns 
     */
    w.Kinougarde.RendezVous.isCible = function (codeEtatCandidature) {
        return !(codeEtatCandidature==11 || codeEtatCandidature==12 || codeEtatCandidature==13 || codeEtatCandidature==14 || codeEtatCandidature==15 || codeEtatCandidature==16)
    }


    /**
     * Retourne le titre du message de confirmation à afficher selon l'état de la candidature
     * @param {} codeEtatCandidat 
     * @returns 
     */
    w.Kinougarde.RendezVous.getTitreConfirmation = function(codeEtatCandidat) {

        if (codeEtatCandidat==10 || codeEtatCandidat==11 || codeEtatCandidat==12 || codeEtatCandidat==13 || codeEtatCandidat==14 || codeEtatCandidat==15 || codeEtatCandidat==16) {
            return "Merci pour ce complément d'informations."
        } else if (codeEtatCandidat==21 || codeEtatCandidat==22 || codeEtatCandidat==31 ||  codeEtatCandidat==32) {
            return "Bonne nouvelle !"
        }        
        else if (codeEtatCandidat==41 || codeEtatCandidat==51) {
            return "Votre rendez-vous est déjà confirmé !";
        } else if (codeEtatCandidat==42 || codeEtatCandidat==52) {
            return "Kinougarde et Momji font partie du même groupe. Votre rendez-vous est déjà confirmé avec Momji !";
        } else if (codeEtatCandidat==60) {
            return "Bonne nouvelle, votre candidature nous intéresse !"
        } else {
            return "Bonne nouvelle !"
        }
    }

    /**
     * Retourne le message de confirmation à afficher selon l'état de la candidature
     * @param {*} codeEtatCandidat 
     */
    w.Kinougarde.RendezVous.getMessageConfirmation = function(codeEtatCandidat) {
        
        
        if ( codeEtatCandidat==11 || codeEtatCandidat==12 || codeEtatCandidat==13 || codeEtatCandidat==14 || codeEtatCandidat==15 || codeEtatCandidat==16) {
            // Cas 10
            return "Notre équipe recrutement va examiner votre candidature.";
        }
        if (codeEtatCandidat==21) {
            return "Vous avez déjà rendez-vous dans notre agence Kinougarde " + Kinougarde_RendezVous.LieuRecrutement + " le <strong>" +  Kinougarde.RendezVous.FormatDateRdv(Kinougarde_RendezVous.DateRendezVous) +"</strong>.<br><br>"
        }
        else if (codeEtatCandidat==22) {
            return "<strong>Kinougarde et Momji font partie du même groupe</strong> et vous avez déjà rendez-vous dans notre agence Momji " + Kinougarde_RendezVous.LieuRecrutement + " le <strong>" +  Kinougarde.RendezVous.FormatDateRdv(Kinougarde_RendezVous.DateRendezVous) +"</strong>.Cet entretien sera valable à la fois pour Kinougarde et Momji.<br><br>";
        }
        else if (codeEtatCandidat==31) {
            return "Vous avez déjà échangé par téléphone avec notre équipe recrutement, la prochaine étape est de prendre rendez-vous pour un entretien dans l’une de nos agences Kinougarde.<br><br>"
        }
        else if (codeEtatCandidat==32 ) {
            return "<strong>Kinougarde et Momji font partie du même groupe</strong> et vous avez déjà échangé par téléphone avec notre équipe recrutement, la prochaine étape est de prendre rendez-vous pour un entretien dans l’une de nos agences Momji.<br><br>"
        }
        else if (codeEtatCandidat==51 || codeEtatCandidat==41) {
            return "Vous avez déjà rendez-vous pour un entretien téléphonique le <strong>" + Kinougarde.RendezVous.FormatDateRdv(Kinougarde_RendezVous.DateRendezVous) + "</strong>."
        }
        else if (codeEtatCandidat==52 || codeEtatCandidat==42) {
            return "Vous avez déjà rendez-vous pour un entretien téléphonique le <strong>" + Kinougarde.RendezVous.FormatDateRdv(Kinougarde_RendezVous.DateRendezVous) + "</strong>.<br><br>"
        }
        else  if (codeEtatCandidat==60) {
            return "C'est le moment d'échanger par téléphone avec nous pendant 10 min.<br><br>";
        } 
        else  if (codeEtatCandidat==71) {
            return "Vous êtes déjà recruté chez Kinougarde.</br>Appelez-nous pour accéder à nos offres de gardes.<br><br>";
        } 
        else  if (codeEtatCandidat==72) {
            return "<strong>Kinougarde et Momji font partie du même groupe</strong> Vous êtes déjà recruté chez Momji.</br>Appelez-nous pour accéder à nos offres de gardes.<br><br>";
        }                
        else {
            return "Notre équipe recrutement va examiner votre candidature."; 
        }
        
    }

    /**
     * Modifie l'état du bouton prendre_rdv selon l'état du candidat
     * @param {*} codeEtatCandidat 
     */
    w.Kinougarde.RendezVous.getParamBoutonModifierRdv = function(codeEtatCandidat) {
        if (codeEtatCandidat==10 || codeEtatCandidat==11 || codeEtatCandidat==12 || codeEtatCandidat==13 || codeEtatCandidat==14 || codeEtatCandidat==15 || codeEtatCandidat==16) {
            return { hide : true}
        } else if (codeEtatCandidat==21) { // Kinou
            return { hide: false ,title : "Modifier mon RDV", href : Kinougarde_RendezVous.UrlExtranet}
        } else if (codeEtatCandidat==22) {// Momji
            return { hide: false ,title : "Modifier mon RDV", href : Kinougarde_RendezVous.UrlExtranet}
        } else if (codeEtatCandidat==31) { // Kinou
            return { hide: false ,title : "Prendre RDV", href : Kinougarde_RendezVous.UrlExtranet}
        } else if (codeEtatCandidat==32 ) { // Momji
            return { hide: false ,title : "Prendre RDV", href : Kinougarde_RendezVous.UrlExtranet}
        } else if (codeEtatCandidat==41) {
            return { hide: false ,title : "Modifier mon RDV", href : Kinougarde_RendezVous.UrlExtranet}
        } else if (codeEtatCandidat==51) {
            return { hide: false ,title : "Modifier mon RDV", href : Kinougarde_RendezVous.UrlRdv}
        } else if (codeEtatCandidat==42) {
            return { hide: false ,title : "Modifier mon RDV", href : Kinougarde_RendezVous.UrlExtranet }
        }  else if (codeEtatCandidat==52) {
            return { hide: false ,title : "Modifier mon RDV", href : Kinougarde_RendezVous.UrlRdv}
        } else if (codeEtatCandidat==60) {
            return { hide: false ,title : "Prendre RDV", href : Kinougarde_RendezVous.UrlRdv}
        } else if (codeEtatCandidat==71 || codeEtatCandidat==72) {
            return { hide : true}
        }
        else {
            return { hide : true}
        }
    }

    /**
     * True le le bouton du numéro de tel de l'agence est visible
     * @param {*} codeEtatCandidat 
     */
    w.Kinougarde.RendezVous.isVisibleBoutonNumeroTel = function(codeEtatCandidat) {
        return (codeEtatCandidat==60  && Kinougarde.isKinougardeOpen()) || codeEtatCandidat==71 || codeEtatCandidat==72;
    }

    /**
     * True si les messages "Vous etes dispo, appelez nous !" et "Pas dispo maintenant prenez rendez-vous!"
     * @param {*} codeEtatCandidat 
     */
    w.Kinougarde.RendezVous.isVisibleMsgDispo = function(codeEtatCandidat) {
        return codeEtatCandidat==60 && Kinougarde.isKinougardeOpen();
    }


    /**
     * Initalise les messages de confirmation en fonction de l'état de la candidature
     */
    w.Kinougarde.RendezVous.setMessageConfirmation = function(codeEtatCandidature) {
        if (Kinougarde.RendezVous.isCible(codeEtatCandidature)) {
            $(".candidat_non_cible").hide();$(".candidat_cible").show();                
        } else {
            $(".candidat_non_cible").show();$(".candidat_cible").hide();                
        }

        $("#titre_candidature p").html(Kinougarde.RendezVous.getTitreConfirmation(codeEtatCandidature));
        $("#msg_candidature p").html(Kinougarde.RendezVous.getMessageConfirmation(codeEtatCandidature));
        const paramBouton =  Kinougarde.RendezVous.getParamBoutonModifierRdv(codeEtatCandidature);
        $("#bouton_prendre_rdv").html(paramBouton.title);
        $("#bouton_prendre_rdv").attr("href" , paramBouton.href);
        $("#bouton_prendre_rdv").closest(".acf-message").toggle(!paramBouton.hide);
        if (Kinougarde.RendezVous.isVisibleBoutonNumeroTel(codeEtatCandidature)) {
            $("#bouton_tel_agence").show();
        } else {
            $("#bouton_tel_agence").hide();
        }
        if (Kinougarde.RendezVous.isVisibleMsgDispo(codeEtatCandidature)) {
            $("#msg_cible_disponible").show();
            $("#msg_cible_non_dispo").show();
        } else {
            $("#msg_cible_disponible").hide();
            $("#msg_cible_non_dispo").hide();
        }
    }

    /**
     * 
     * @returns Format la date de rendez-vous sous forme de string
     */
    w.Kinougarde.RendezVous.FormatDateRdv = function($date) {
        if ($date!==null) {
            var date = new Date($date);
            date.toLocaleDateString("fr");
            var stringdate = date.toLocaleDateString('fr-FR',{weekday: 'long',day :'2-digit', month:'long'})+ " à " + (date.toLocaleTimeString('fr-FR',{hour :'2-digit',minute:'2-digit'})).replace(':','h'); 
            return stringdate.charAt(0).toUpperCase() + stringdate.slice(1)
        }
        return null;
    }
    
})(window);

jQuery(function() {
    try {
    if (jQuery("#section-mon-rendez-vous").length>0) {               
        Kinougarde.RendezVous.initFormulaire();        
    };   
    }     
    catch (ex) {
        console.error(ex);
    }
});